module.exports = __webpack_public_path__ + "static/media/remove.73e18f94.svg";